export const getGuid = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (
      +c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
    ).toString(16)
  );
};

export const getAgeAtYearEnd = (dateStr) => {
  if (!dateStr) return null;

  const dob = new Date(dateStr);
  if (isNaN(dob.getTime())) return null; // invalid date check

  const currentYear = new Date().getFullYear();
  const endOfYear = new Date(currentYear, 11, 31); // 31/12

  let age = endOfYear.getFullYear() - dob.getFullYear();
  if (
    endOfYear.getMonth() < dob.getMonth() ||
    (endOfYear.getMonth() === dob.getMonth() &&
      endOfYear.getDate() < dob.getDate())
  ) {
    age--;
  }

  return age;
};